import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./init";

export const subscribeToLedgerSync = (userId, onUpdate) => {
    if (!userId || typeof onSnapshot !== "function") {
        return () => {};
    }
    try {
        const ref = doc(db, "binance_ledger_summary", String(userId));
        const unsubscribe = onSnapshot(
            ref,
            (snapshot) => {
                if (
                    snapshot &&
                    typeof snapshot.exists === "function" &&
                    snapshot.exists() &&
                    typeof onUpdate === "function"
                ) {
                    onUpdate(snapshot.data());
                }
            },
            () => {}
        );
        return typeof unsubscribe === "function" ? unsubscribe : () => {};
    } catch (e) {
        return () => {};
    }
};

export default subscribeToLedgerSync;
